module.exports = __webpack_public_path__ + "img/video6.95b52c23.png";